import { pack } from '@attain-apps/data-utils'
import * as ents from '@attain-apps/entities'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as assistants from '../../../../../../assistants'
import type * as display from '../../../../../../display'
import type * as me from '../../../../../../me'
import type * as variableOverrides from '../../../../../../variable-overrides'
import type * as currentRendering from '../../../feature'
import type { Feature } from '../feature'

/** TODO:  */
export const executeUiActions = store.effects.create(
  (
    feature: Feature,
    currentRenderingFeature: currentRendering.Feature,
    meFeature: me.Feature,
    toasterFeature: display.toaster.Feature,
    _router: router.Router,
    variablesFeature: variableOverrides.Feature,
    assistantsFeature: assistants.Assistants,
  ) =>
    feature.actions.executeAction.success.observe().pipe(
      rxjs.switchMap(action =>
        rxjs.from(action.data.response.executedInUi).pipe(
          // Done as inner observable processing
          rxjs.concatMap(({ operation, payload }) => {
            if (!operation || !payload) {
              // Does nothing if there is not enough information to execute the
              // action
              return []
            }
            switch (operation) {
              case ents.core.mosaic.Action.Operation.UiNavigate:
                return meFeature.contexts.selectors
                  .getUrlForLink(payload)
                  .asObservable.pipe(
                    // TODO: Explain why take one
                    rxjs.take(1),
                    // TODO: what to do when getUrlForLink returns undefined,
                    // should we return rxjs.EMPTY?
                    rxjs.filter(TypeChecker.isNotNullish.raw),
                    rxjs.map(url =>
                      _router.actions.navigate.from(action).create({ url }),
                    ),
                  )
              case ents.core.mosaic.Action.Operation.UiModal:
                return rxjs.of(
                  currentRenderingFeature.subfeatures.modal.actions.setModal
                    .from(action)
                    .create({ widgetRef: payload }),
                )
              case ents.core.mosaic.Action.Operation.UiSlideout:
                return rxjs.of(
                  currentRenderingFeature.subfeatures.slideout.actions.setSlideout
                    .from(action)
                    .create({ widgetRef: payload }),
                )
              case ents.core.mosaic.Action.Operation.UiSetVariables: {
                const { widget, appId, scenarioId, pageId } =
                  action.data.request.context

                if (widget) {
                  const { id: widgetId, refId } = widget
                  return rxjs.of(
                    variablesFeature.actions.addValues.from(action).create({
                      request: {
                        holder: {
                          widget: {
                            appId,
                            pageId,
                            refId,
                            scenarioId,
                            widgetId,
                          },
                        },
                        // NOTE: variable values are merged with the existing ones from the state
                        values: payload.variables ?? {},
                      },
                    }),
                  )
                } else {
                  return rxjs.of(
                    variablesFeature.actions.addValues.from(action).create({
                      request: {
                        holder: { page: { appId, pageId, scenarioId } },
                        // NOTE: variable values are merged with the existing ones from the state
                        values: payload.variables ?? {},
                      },
                    }),
                  )
                }
              }
              case ents.core.mosaic.Action.Operation.UiNotify:
                return payload
                  ? rxjs.of(
                      toasterFeature.actions.show.from(action).create({
                        toasts: pack(payload).map(notice => ({
                          description: notice.description,
                          name: notice.name,
                          style: notice.style,
                        })),
                      }),
                    )
                  : []
              case ents.core.mosaic.Action.Operation.UiOpenAssistant:
                assistantsFeature.openWithKnowledgeBaseContext(
                  payload.agentId,
                  payload.records,
                )
                return []
            }
          }),
        ),
      ),
    ),
)
